import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=ed520682&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\tatu\\tatu_25_5_24\\3.1源代码_25_4_3\\前端-源代码\\smart-battery-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed520682"]])

export default __exports__